import axios from "axios";
import { ADD_USER_URL } from "../../config/apiConfig";

/**
 * Sign up a new user.
 * @param {Object} payload - { username, email, password, user_role }
 * @returns {Promise<{ customer_id: number, message: string }>}
 */
export const signUpUser = async (payload) => {
  const response = await axios.post(ADD_USER_URL, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};
